import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./presentation/screen/App";
import { Provider } from "react-redux";
import store from "./store/store";

const div = document.getElementById("root") as HTMLElement;

const root = ReactDOM.createRoot(div);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
